import { actionTypes } from '../actionTypes'
import * as  APIService from '../apiService';
import tokenStorageService from '../../helpers/tokenStorageService'

const BRONCO_PREFIX = process.env.REACT_APP_BRONCO_PREFIX;

export const logout = () => {
    const key = {
        'session_key': APIService.getSessionKey()
    }
    return (dispatch: any) => {
        return fetch(`${BRONCO_PREFIX}/logout`, {
            method: 'POST',
            body: JSON.stringify(key),
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
        })
            .then(res => res.json())
            .then((json: any) => {
                tokenStorageService.clearUserInfo()
                dispatch(logoutSuccess());
            })
            .catch(error => dispatch(logoutFailure(error)));
    };
}

export const logoutSuccess = () => {
    return ({
        type: actionTypes.LOGOUT_SUCCESS,
    });
}

export const logoutFailure = (error: any) => {
    return ({
        type: actionTypes.LOGOUT_FAILURE,
    });
}

export const login = (username: string, password: string) => {
    // Check Login API HERE;
    const formData = {
        "email": username,
        "pass": password
    }
    return (dispatch: any) => {
        return fetch(`${BRONCO_PREFIX}/login`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
        })
            .then(res => res.json())
            .then((json: any) => {
                if (json.error) {
                    dispatch(loginFailure(json))
                }
                else {
                    tokenStorageService.updateUserInfo(json);
                    dispatch(loginSuccess(json));
                }
            })
            .catch(error => dispatch(loginFailure(error)));
    };
}

export const loginSuccess = (payload: any) => {
    return ({
        type: actionTypes.LOGIN_SUCCESS,
        payload
    });
}


export const loginFailure = (error: any) => {
    return ({
        type: actionTypes.LOGIN_FAILURE,
        error
    })
}



// WEBPACK FOOTER //
// ./src/store/login/action.ts